import React from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";

interface EditableTextCellProps {
  value: string;
  hasError: boolean;
  onChange: (value: string) => void;
  placeholder?: string;
  transform?: (value: string) => string;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
}

export const EditableTextCell: React.FC<EditableTextCellProps> = ({
  value,
  hasError,
  onChange,
  placeholder,
  transform,
  inputProps,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = transform ? transform(e.target.value) : e.target.value;
    onChange(newValue);
  };

  return (
    <Box sx={{ width: "100%", px: 0.5 }}>
      <TextField
        size="small"
        fullWidth
        value={value}
        onChange={handleChange}
        onKeyDown={(e) => e.stopPropagation()}
        placeholder={placeholder}
        error={hasError}
        inputProps={inputProps}
        sx={{
          "& .MuiInputBase-input": { fontSize: "0.875rem" },
          "& .MuiOutlinedInput-root": {
            backgroundColor: hasError ? "error.50" : undefined,
          },
        }}
      />
    </Box>
  );
};

export default EditableTextCell;
